"use client";

import { ArrowDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section id="hero" className="relative h-screen w-full overflow-hidden bg-dark-background">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-fixed bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1529869/img/wedding_reception_softly_lit.png)]" aria-hidden="true" />

      {}
      <div className="absolute inset-0 surface-overlay" aria-hidden="true" />

      {}
      <div ref={ref} className={`relative z-10 flex h-full flex-col items-center justify-center px-4 text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
        {}
        <h1 className="mb-4 text-4xl font-bold text-foreground-dark sm:text-5xl md:text-6xl lg:text-7xl">
          Make Your Special Day Unforgettable
        </h1>

        {}
        <p className="mb-8 max-w-2xl text-lg text-foreground-dark/90 sm:text-xl md:text-2xl">
          Denver's premier wedding DJ and AV specialist bringing years of
          experience to create the celebration you deserve
        </p>

        {}
        <Link to="#contact">
          <Button size="lg" className="btn-primary shadow-strong hover:shadow-strong hover:scale-105 active:scale-100">
            Let's Talk About Your Event
          </Button>
        </Link>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 z-10 -translate-x-1/2 animate-bounce">
        <ArrowDown className="size-8 text-foreground-dark opacity-80" aria-label="Scroll down" />
      </div>
    </section>;
}